import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Backdrop } from '@mui/material';

// const useStyles = makeStyles( theme => ({
//     headers: {
//         background: theme.palette.primary,
//         display: 'grid',
//         gridTemplateColumns: '15rem 15fr 5fr',
//         direction: 'ltr',
//         textAlign: 'center'
//     }
//   }));

export default function ProgressWait(statusWait)  {
    // const classcs = useStyles();
    const [open, setOpen] = React.useState(true);

    const handleClose = () => {
        setOpen(false);
    };
    // const handleOpen = () => {
    //     setOpen(true);
    // };
    
  return (
    <div>
      
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={statusWait}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

// export default ProgressWait;